import {any, complement, isNil, values} from 'ramda'

import {removeEmpty} from '@vio/core/src/utils/object'

import {makeGetSearchParameter} from './generic'

import type {FilterParameters, SearchParameters} from '@findhotel/sapi'

/**
 * Returns all filter parameters in the format expected by SAPI
 */
export const getFilters = (
  searchParameters: URLSearchParams
): FilterParameters => {
  const getParameter = makeGetSearchParameter(searchParameters)

  return removeEmpty({
    starRating: getParameter('starRatings', 'number', true),
    guestRating: getParameter('reviewScore', 'number', true),
    propertyTypeId: getParameter('propertyTypes', 'number', true),
    facilities: getParameter('facilities', 'number', true),
    themeIds: getParameter('themes', 'number', true),
    chainIds: getParameter('chainIds', 'number', true),
    noHostels: getParameter('noHostels', 'boolean'),
    priceMin: getParameter('priceMin', 'number'),
    priceMax: getParameter('priceMax', 'number'),
    hotelName: getParameter('hotelName'),
    freeCancellation: getParameter('freeCancellation', 'boolean'),
    amenities: getParameter('amenities', 'string', true),
    payLater: getParameter('payLater', 'boolean'),
    exclusive: getParameter('exclusive', 'boolean'),
    brandIds: getParameter('brandIds', 'string', true),
    neighborhoodIds: getParameter('neighborhoodIds', 'string', true),
    dealFreeze: getParameter('dealFreeze', 'boolean') // Added as a part of c747927f-deal-freeze-srp
  })
}

export const hasFilters = (filters: SearchParameters['filters'] = {}) =>
  any(complement(isNil), values(filters))
